export default "__VITE_ASSET__f30e2c29__"